import type {CmpHider} from './types';
import {didomi} from './didomi';
import {ccc} from './ccc';
import {onetrust} from './onetrust';
import {cookiebot} from './cookiebot';
import {usercentrics} from './usercentrics';
import {trustarc} from './trustarc';
import {quantcast} from './quantcast';
import {osano} from './osano';
import {sourcepoint} from './sourcepoint';
import {termly} from './termly';
import {cookieyes} from './cookieyes';
import {securiti} from './securiti';
import {ketch} from './ketch';
import {axeptio} from './axeptio';
import {cookieInformation} from './cookie-information';
import {piwikPro} from './piwik-pro';
import {crownpeak} from './crownpeak';
import {securePrivacy} from './secure-privacy';
import {enzuzo} from './enzuzo';
import {complianz} from './complianz';
import {borlabs} from './borlabs';
import {cookiefirst} from './cookiefirst';
import {tarteaucitron} from './tarteaucitron';
import {klaro} from './klaro';
import {vanillaCookieConsent} from './vanilla-cookieconsent';
import {framer} from './framer';
import {hubspotWebInteractives} from './hubspot-web-interactives';
export type { CmpHider } from './types';

/**
 * Per-provider CSS that hides a page's own overlays in the editor preview:
 * one entry per cookie-consent CMP, plus other fixed overlays a page mounts
 * over itself (HubSpot Web Interactives popups and banners). Same mechanism,
 * same registry — the folder name predates the non-CMP entries.
 */
export const CMP_HIDERS: CmpHider[] = [
  didomi,
  onetrust,
  ccc,
  cookiebot,
  usercentrics,
  trustarc,
  quantcast,
  osano,
  sourcepoint,
  termly,
  cookieyes,
  securiti,
  ketch,
  axeptio,
  cookieInformation,
  piwikPro,
  crownpeak,
  securePrivacy,
  enzuzo,
  complianz,
  borlabs,
  cookiefirst,
  tarteaucitron,
  klaro,
  vanillaCookieConsent,
  framer,
  hubspotWebInteractives,
];
